import axios from 'axios';
import SelectedScenario from "./SelectedScenario";
  
  function updateScenarioGraphIfNotUpdated(scenario: SelectedScenario, strategy: string | undefined): SelectedScenario | Promise<SelectedScenario> {
    if (scenario.scenarioDisplayProps.updated) {
      // TODO: graph updating avoids duplicate calls to backend
      return scenario;
    } else {
      return axios
        .get("/api/scenario/plot", {
          params: {
            scenarioName: scenario.scenario,
            params: scenario.params,
            strategy: strategy,
          },
          paramsSerializer: {
            indexes: true,
          },
        })
        .then((response) => {
          const newScenario: SelectedScenario = {
            ...scenario,
            scenarioDisplayProps: {
              plotTitle: response.data["graph_title"],
              plotSubtitle: response.data["graph_subtitle"],
              plotExtraInfo: response.data["graph_extra_info"],
              plotJson: response.data["graph_json"],
              totalValue: response.data["total_value"],
              coreStockValue: response.data["core_stock_value"],
              otherStockValue: response.data["other_stock_value"],
              cashValue: response.data["cash_value"],
              sharpeRatio: response.data["sharpe_ratio"],
              taxSavings: response.data["tax_savings"],
              symbol: response.data["symbol"],
              otherSymbol: response.data["other_stock_name"],
              maxPortfolioValue: response.data["max_portfolio_value"],
              maxStockPrice: response.data["max_stock_price"],
              referenceDateString: response.data["reference_date_string"],
              futureReferenceDateString: response.data["future_reference_date_string"],
              updated: true,
              yearEndStats: "year_end_stats" in response.data ? {
                totalValue: response.data["year_end_stats"]["total_value"],
                coreStockValue: response.data["year_end_stats"]["core_stock_value"],
                otherStockValue: response.data["year_end_stats"]["other_stock_value"],
                cashValue: response.data["year_end_stats"]["cash_value"],
                futureReferenceDateString: response.data["year_end_stats"]["future_reference_date_string"],
              }: undefined,
              oneYearStats: "one_year_stats" in response.data ? {
                totalValue: response.data["one_year_stats"]["total_value"],
                coreStockValue: response.data["one_year_stats"]["core_stock_value"],
                otherStockValue: response.data["one_year_stats"]["other_stock_value"],
                cashValue: response.data["one_year_stats"]["cash_value"],
                futureReferenceDateString: response.data["one_year_stats"]["future_reference_date_string"],
              }: undefined,
              twoYearStats: "two_year_stats" in response.data ? {
                totalValue: response.data["two_year_stats"]["total_value"],
                coreStockValue: response.data["two_year_stats"]["core_stock_value"],
                otherStockValue: response.data["two_year_stats"]["other_stock_value"],
                cashValue: response.data["two_year_stats"]["cash_value"],
                futureReferenceDateString: response.data["two_year_stats"]["future_reference_date_string"],
              }: undefined,
            },
          };
          return newScenario; 
        })
        .catch((error) => {
          if (process.env.NODE_ENV === "development") {
              console.error(error);
            }
          throw error;
        });
    }
  }

  export default updateScenarioGraphIfNotUpdated;